module.exports = __webpack_public_path__ + "media/assets/consultation/budget_25000-596d958ba7e8a3ea81abdacec1c77fb9.svg";